import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ArchiveActions from "archive/ArchiveActions";
import { Row, Col, MenuItem } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import { Spinner } from "components/common";
const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 400px;
`;
const ArchiveCatalogExportModal = ({ query }) => {
  const { t } = useTranslation("enterprise_archive");
  const [filenames, setFilenames] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const close = () => setShowModal(false);
  const open = () => {
    setShowModal(true);
    ArchiveActions.exportFilenames(query).then((response) => setFilenames(response.filenames));
  };
  const _onSubmit = (e) => {
    e.preventDefault();
    close();
  };
  const _isLoading = () => !filenames;
  const modalContent = () => {
    if (_isLoading()) {
      return /* @__PURE__ */ React.createElement(Spinner, { text: t("archive_catalog_export_modal.loading_filenames") });
    }
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledTextArea, { value: filenames.join("\n"), readOnly: true })));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: open }, t("archive_catalog_export_modal.filenames")), /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: showModal,
      onCancel: close,
      title: t("archive_catalog_export_modal.title"),
      onSubmitForm: _onSubmit,
      submitButtonText: t("archive_catalog_export_modal.close")
    },
    modalContent()
  ));
};
export default ArchiveCatalogExportModal;
